<template>
  <div
    class="survey-title"
    v-html="questionText"
    :style="{ color: color }"
  ></div>
</template>
<script>
export default {
  props: {
    questionText: {
      type: String,
    },
    color: {
      type: String,
    },
  },
};
</script>
<style scoped>
.survey-title {
  font-size: 16px;
  line-height: 20px;
  color: #354052;
  margin: 0;
  width: 100%;
}
</style>
